module.exports = "<span class=\"circle\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpCircleIcon/adpCircleIcon.html
// module id = 705
// module chunks = 0